import { cn } from '@/lib/utils/cn';

/** Shape-matched placeholder with a shimmer sweep. */
export function Skeleton({ className }: { className?: string }) {
  return <div className={cn('shimmer rounded-md', className)} aria-hidden />;
}
